import React from 'react'

const Instagram = (props) => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill={props ? props.color : '#000000'}
         xmlns="http://www.w3.org/2000/svg">
        <g opacity={props ? props.opacity : '0.5'}>
            <path
                d="M10.6428 0H4.35727C1.95466 0 0 1.95466 0 4.35727V10.6427C0 13.0453 1.95466 15 4.35727 15H10.6427C13.0453 15 15 13.0453 15 10.6428V4.35727C15 1.95466 13.0453 0 10.6428 0ZM13.8281 10.6427C13.8281 12.3992 12.3992 13.8281 10.6428 13.8281H4.35727C2.60083 13.8281 1.17188 12.3992 1.17188 10.6428V4.35727C1.17188 2.60083 2.60083 1.17188 4.35727 1.17188H10.6427C12.3992 1.17188 13.8281 2.60083 13.8281 4.35727V10.6427Z"
            />
            <path
                d="M7.5 3.45703C5.27068 3.45703 3.45703 5.27068 3.45703 7.5C3.45703 9.72932 5.27068 11.543 7.5 11.543C9.72932 11.543 11.543 9.72932 11.543 7.5C11.543 5.27068 9.72932 3.45703 7.5 3.45703ZM7.5 10.3711C5.91688 10.3711 4.62891 9.08312 4.62891 7.5C4.62891 5.91688 5.91688 4.62891 7.5 4.62891C9.08312 4.62891 10.3711 5.91688 10.3711 7.5C10.3711 9.08312 9.08312 10.3711 7.5 10.3711Z"
            />
            <path
                d="M11.6016 3.98438C11.9252 3.98438 12.1875 3.72204 12.1875 3.39844C12.1875 3.07483 11.9252 2.8125 11.6016 2.8125C11.278 2.8125 11.0156 3.07483 11.0156 3.39844C11.0156 3.72204 11.278 3.98438 11.6016 3.98438Z"
            />
        </g>
    </svg>
)

export default Instagram
